import axios from '@axios'

export default {
    namespaced: true,
    state: {
        data: [],
        dataExt: [],
        piscinas: [],
        zonasProf: [],
        sectoresProf: [],
        camaronerasProf: [],
        piscinasProf: [],
        zonas: [],
        camaroneras: [],
        sectores: [],
        fields: [],
        sabores: [],
        niveles: [],
        defectos: [],
        procesos: [],
        establecimientos: [],
        multianalisis: [],
        centros: [],
        rutas: [],
        tiposD: [],
        guiasRaleo: [],
        proveedores: [],
        camaronerasXProv: [],
        guias: [],
        plantaDestino: [],
        camaroneraDestino: [],
        zonasEmpresa: [],
        ciaTransporte: [],
        movilesDestino: [],
        estadoBines:[],
    },

    getters: {
        getData(state) {
            return state.data;
        },
        getDataExt(state) {
            return state.dataExt;
        },
        getPiscinas(state) {
            return state.piscinas;
        },
        getZonasProf(state) {
            return state.zonasProf;
        },
        getCamaronerasProf(state) {
            return state.camaronerasProf;
        },
        getSectoresProf(state) {
            return state.sectoresProf;
        },
        getPiscinasProf(state) {
            return state.piscinasProf;
        },

        getZonas(state) {
            return state.zonas;
        },

        getCamaroneras(state) {
            return state.camaroneras;
        },

        getMovilesDestino(state) {
            return state.movilesDestino;
        },

        getSectores(state) {
            return state.sectores;
        },
        getFields(state) {
            return state.fields;
        },
        getSabores(state) {
            return state.sabores;
        },
        getNiveles(state) {
            return state.niveles;
        },
        getDefectos(state) {
            return state.defectos;
        },
        getProcesos(state) {
            return state.procesos;
        },
        getEstablecimientos(state) {
            return state.establecimientos;
        },
        getMultianalisis(state) {
            return state.multianalisis;
        },
        getCentrosDistribucion(state) {
            return state.centros;
        },
        getRutasDistribicion(state) {
            return state.rutas;
        },
        getTiposDistribicion(state) {
            return state.tiposD;
        },
        getGuiasRaleo(state) {
            return state.guiasRaleo;
        },
        getProveedores(state) {
            return state.proveedores;
        },
        getCamaronerasXProv(state) {
            return state.camaronerasXProv;
        },
        getGuias(state) {
            return state.guias;
        },
        getPlantaDestino(state) {
            return state.plantaDestino;
        },
        getCamaroneraDestino(state) {
            return state.camaroneraDestino;
        },
        getZonasEmpresa(state) {
            return state.zonasEmpresa;
        },
        getCiaTransporte(state) {
            return state.ciaTransporte;
        },
        getEstadoBines(state) {
            return state.estadoBines;
        },
    },

    mutations: {
        setData(state, data) {
            state.data = data;
        },
        setDataExt(state, dataExt) {
            state.dataExt = dataExt;
        },
        setPiscinas(state, pisc) {
            state.piscinas = pisc;
        },
        setZonasProf(state, zonasProf) {
            state.zonasProf = zonasProf;
        },
        setCamaronerasProf(state, camaronerasProf) {
            state.camaronerasProf = camaronerasProf;
        },
        setSectoresProf(state, sectoresProf) {
            state.sectoresProf = sectoresProf;
        },
        setPiscinasProf(state, piscinasProf) {
            state.piscinasProf = piscinasProf;
        },
        setZonas(state, zonas) {
            state.zonas = zonas;
        },
        setCamaroneras(state, camaroneras) {
            state.camaroneras = camaroneras;
        },
        setSectores(state, sectores) {
            state.sectores = sectores;
        },
        setSectores(state, sectores) {
            state.sectores = sectores;
        },
        setFields(state, fields) {
            state.fields = fields;
        },
        setDefectos(state, defectos) {
            state.defectos = defectos;
        },
        setSabores(state, sabores) {
            state.sabores = sabores;
        },
        setNiveles(state, niveles) {
            state.niveles = niveles;
        },
        setProcesos(state, procesos) {
            state.procesos = procesos;
        },
        setEstablecimientos(state, establecimientos) {
            state.establecimientos = establecimientos;
        },
        setMultianalisis(state, multianalisis) {
            state.multianalisis = multianalisis;
        },
        setCentrosDistribucion(state, centros) {
            state.centros = centros;
        },
        setRutasDistribucion(state, rutas) {
            state.rutas = rutas
        },
        setTiposDistribucion(state, tiposD) {
            state.tiposD = tiposD
        },
        setGuiasRaleo(state, guiasRaleo) {
            state.guiasRaleo = guiasRaleo
        },
        setProveedores(state, proveedores) {
            state.proveedores = proveedores
        },
        setCamaronerasXProv(state, camaronerasXProv) {
            state.camaronerasXProv = camaronerasXProv
        },
        setGuias(state, guias) {
            state.guias = guias
        },
        setPlantaDestino(state, plantaDestino) {
            state.plantaDestino = plantaDestino
        },
        setCamaroneraDestino(state, camaroneraDestino) {
            state.camaroneraDestino = camaroneraDestino;
        },
        setMovilesDestino(state, movilesDestino) {
            state.movilesDestino = movilesDestino;
        },
        setZonasEmpresa(state, zonasEmpresa) {
            state.zonasEmpresa = zonasEmpresa;
        },
        setCiaTransporte(state, ciaTransporte) {
            state.ciaTransporte = ciaTransporte;
        },
        setEstadoBines(state, estadoBines) {
            state.estadoBines = estadoBines;
        },
    },

    actions: {
        fetchData({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/monitoreoPesca/datos", data)
                    .then((response) => {
                        commit("setData", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchDataExt({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/monitoreoPesca/datosExt", data)
                    .then((response) => {
                        commit("setDataExt", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchPiscinas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/piscinas", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchCambiarEstadoPisc({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/cambiarEstPisc", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchAddPisc({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/addPisc", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchZonasProf({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/zonasProf", {
                        params: data,
                    })
                    .then((response) => {
                        commit("setZonasProf", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchCamaronerasProf({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/camaronerasProf/" + data)
                    .then((response) => {
                        commit("setCamaronerasProf", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchSectoresProf({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/sectoresProf/" + data)
                    .then((response) => {
                        commit("setSectoresProf", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchPiscinasProf({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/piscinasProf/" + data)
                    .then((response) => {
                        commit("setPiscinasProf", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchZonas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/zonasProfPag", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchCambiarEstadoZonas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/cambiarEstZona", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchAddZonas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/addZona", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchEditZonas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/editZona", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchCamaroneras({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/camaronerasProfPag", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchCambiarEstadoCama({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/cambiarEstCama", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchAddCamaroneras({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/addCamaronera", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchEditCama({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/editCama", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchEditPisc({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/editPiscina", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchSectores({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/sectoresProfPag", {
                        params: data,
                    })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchCambiarEstadoSector({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/cambiarEstSector", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchAddSector({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/addSector", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchEditSector({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/editSector", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchFields({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/fieldsForRol")
                    .then((response) => {
                        commit("setFields", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchSabores({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/sabores")
                    .then((response) => {
                        commit("setSabores", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchNiveles({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/niveles")
                    .then((response) => {
                        commit("setNiveles", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchDefectos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/defectos")
                    .then((response) => {
                        commit("setDefectos", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchProcesos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/procesos")
                    .then((response) => {
                        commit("setProcesos", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchEstabDistribucion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/estabDistribucion")
                    .then((response) => {
                        commit("setEstablecimientos", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchDistribucion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/saveDistribucion", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchDatosDistribucion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/getDistribucion", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchMultianalisis({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/cantAnalisis")
                    .then((response) => {
                        commit("setMultianalisis", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchCentrosDistribucion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/centrosDistribucion")
                    .then((response) => {
                        commit("setCentrosDistribucion", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchRutasDistribucion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/rutasDistribucion", { params: data })
                    .then((response) => {
                        commit("setRutasDistribucion", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchTipoDistribucion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/tiposDistribucion", { params: data })
                    .then((response) => {
                        commit("setTiposDistribucion", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchconsultarRuta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/consultarRuta", { params: data })
                    .then((response) => {
                        //commit("setTiposDistribucion", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchEditRuta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/editRuta", data)
                    .then((response) => {
                        //commit("setTiposDistribucion", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchGetRuta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/getRuta", { params: data })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });

        },

        fetchGuiasRaleo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/getGuiasRaleo", {
                        params: data,
                    })
                    .then((response) => {
                        commit("setGuiasRaleo", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchProveedores({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/proveedores")
                    .then((response) => {
                        commit("setProveedores", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchCamaronerasXProv({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/getCamaronerasXProv/" + data)
                    .then((response) => {
                        commit("setCamaronerasXProv", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },


        fetchEditCamPisc({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/editCamPisc", data)
                    .then((response) => {
                        //commit("setTiposDistribucion", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchGetGuia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/getGuia", { params: data })
                    .then((response) => {
                        commit("setGuias", response.data);
                        resolve(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchGetPlantaDestino({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/getPlantasDestino", {
                        params: data,
                    })
                    .then((response) => {
                        commit("setPlantaDestino", response.data);

                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchGetMovilDestino({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/getMovilDestino", {
                        params: data,
                    })
                    .then((response) => {
                        commit("setMovilesDestino", response.data);
                        resolve(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },


        fetchGetEmpresasZonas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/getEmpresaZonas", {
                        params: { nombre: data },
                    })
                    .then((response) => {
                        commit("setZonas", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchGetGuia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/getGuia", { params: data })
                    .then((response) => {
                        commit("setGuias", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchDatosEmpresaZona({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/getDatosEmpresaZona", {
                        params: { co_empresa: data },
                    })
                    .then((response) => {
                        commit("setZonasEmpresa", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchGetCamaroneraDestino({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/getCamaronerasDestino", {
                        params: data,
                    })
                    .then((response) => {
                        commit("setCamaroneraDestino", response.data);
                        resolve(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchEditDestino({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/editDestino", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchGetGuia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/getGuia", { params: data })
                    .then((response) => {
                        commit("setGuias", response.data);
                        resolve(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchGetPlantaDestino({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/getPlantasDestino", { params: data })
                    .then((response) => {
                        commit("setPlantaDestino", response.data);
                        resolve(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchGetCamaroneraDestino({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/getCamaronerasDestino", { params: data })
                    .then((response) => {
                        commit("setCamaroneraDestino", response.data);
                        resolve(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchEditDestino({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/editDestino", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchModificarPrecioZona({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/ModificarPrecioZona", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchDesaprobarPrecioZona({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/DesaprobarPrecioZona", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchGetLugarReal({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/getFleteFalso", { params: data })
                    .then((response) => {
                        //commit("setCiaTransporte", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },
        fetchCiaTransporte({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/getCias", { params: data })
                    .then((response) => {
                        commit("setCiaTransporte", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });

        },

        fetchEstadoBines({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/auth/logistica/getEstadoBines", { params: data })
                    .then((response) => {
                        commit("setEstadoBines", response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });

        },

        fetchEditEstadoBines({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/editEstadoBines", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchFotosBines({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/getFotosBines", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchConvalidarCamaronera({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/convalidarCamaronera", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchConvalidarZona({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/convalidarZona", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchConvalidarSector({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/convalidarSector", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

        fetchConvalidarPiscina({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/logistica/convalidarPiscina", data)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.error(error);
                    });
            });
        },

    },
};